type ChartPlotAreaBox = {
  left: number;
  top: number;
  width: number;
  height: number;
};

type BuildChartPlotAreaFillSxParams = {
  backgroundColor: string;
  inset: number;
  plotBounds: ChartPlotAreaBox;
};

type BuildChartPlotAreaFrameSxParams = {
  color: string;
  inset: number;
  plotBounds: ChartPlotAreaBox;
  strokeWidth: number;
};

type PlotAreaFrameSide = 'top' | 'left' | 'right' | 'bottom';

export const buildChartPlotAreaFillSx = ({
  backgroundColor,
  inset,
  plotBounds,
}: BuildChartPlotAreaFillSxParams): Record<string, string | number> => ({
  position: 'absolute',
  left: plotBounds.left + inset,
  top: plotBounds.top + inset,
  width: Math.max(0, plotBounds.width - inset * 2),
  height: Math.max(0, plotBounds.height - inset),
  backgroundColor,
  pointerEvents: 'none',
  zIndex: 0,
});

export const buildChartPlotAreaFrameSegmentSx = ({
  color,
  inset,
  plotBounds,
  strokeWidth,
  side,
}: BuildChartPlotAreaFrameSxParams & {
  side: PlotAreaFrameSide;
}): Record<string, string | number> => {
  const left = plotBounds.left + inset;
  const top = plotBounds.top + inset;
  const width = Math.max(0, plotBounds.width - inset * 2);
  const height = Math.max(0, plotBounds.height - inset);
  const strokeWidthPx = `${strokeWidth}px`;

  if (side === 'top') {
    return {
      position: 'absolute',
      left,
      top,
      width,
      height: strokeWidthPx,
      backgroundColor: color,
      pointerEvents: 'none',
      zIndex: 0,
    };
  }

  if (side === 'left') {
    return {
      position: 'absolute',
      left,
      top,
      width: strokeWidthPx,
      height,
      backgroundColor: color,
      pointerEvents: 'none',
      zIndex: 0,
    };
  }

  if (side === 'right') {
    return {
      position: 'absolute',
      left: left + Math.max(0, width - strokeWidth),
      top,
      width: strokeWidthPx,
      height,
      backgroundColor: color,
      pointerEvents: 'none',
      zIndex: 0,
    };
  }

  return {
    position: 'absolute',
    left,
    top: top + Math.max(0, height - strokeWidth),
    width,
    height: strokeWidthPx,
    backgroundColor: color,
    pointerEvents: 'none',
    zIndex: 0,
  };
};
